import type { ActiveFeatureMode, FeatureModeSnapshot } from "./FeatureModeTypes";

export class FeatureModeStore {
  private snapshot: FeatureModeSnapshot = {
    activeMode: null,
  };

  private readonly listeners = new Set<(snapshot: FeatureModeSnapshot) => void>();

  public getSnapshot(): FeatureModeSnapshot {
    return this.snapshot;
  }

  public setActiveMode(activeMode: ActiveFeatureMode): void {
    const current = this.snapshot.activeMode;

    if (
      current &&
      current.id === activeMode.id &&
      current.titleKey === activeMode.titleKey &&
      current.fallbackTitle === activeMode.fallbackTitle
    ) {
      return;
    }

    this.snapshot = { activeMode };
    this.emit();
  }

  public clear(): void {
    if (!this.snapshot.activeMode) {
      return;
    }

    this.snapshot = { activeMode: null };
    this.emit();
  }

  public subscribe(listener: (snapshot: FeatureModeSnapshot) => void): () => void {
    this.listeners.add(listener);
    listener(this.snapshot);
    return () => this.listeners.delete(listener);
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener(this.snapshot);
    }
  }
}